const userDeviceBulkContentType = {
    all: 0,
    stories: 1,
    podcasts: 2,
    shiurim: 3,
    stations: 4,
};

export default userDeviceBulkContentType;
